<template>
  <!-- <div id="app">
    <img alt="Vue logo" src="./assets/logo_Tw.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/>
  </div> -->

  <v-app style="margin: 0px; overflow-x:hidden; overflow-y:hidden" >
    <router-view/>
  </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    // HelloWorld
  }
}
</script>

<style>
#app {
  font-family: Arial, Avenir, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
